import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { Autocomplete } from '../../autocomplete';
import { FlexBox } from '../../box';
import { Checkbox } from '../../checkbox';
import { Divider } from '../../divider';
import { Typography } from '../../typography';
import { FACILITY_PICKER_PERMISSION_WIDTH } from '../index';
import { FacilityFilter } from './facility-filter';
import { FacilitySearch } from './facility-search';
export function FacilityPopperHeader(props) {
    const { tags = [], filterTags = [], search = '', selectConfig, searchPlaceholder, permissionConfig, autocompleteInputRef } = props;
    const divider = _jsx(Divider, { sx: { my: 1 } });
    return (_jsxs(FlexBox, { paddingTop: 0.75, stack: true, children: [_jsx(FacilitySearch, { search: search, placeholder: searchPlaceholder, autocompleteInputRef: autocompleteInputRef, onSearch: (search) => props.onFilter?.(search, filterTags) }), divider, tags.length > 0 && (_jsxs(_Fragment, { children: [_jsx(FacilityFilter, { tags: tags, selected: filterTags, onFilter: (tags) => props.onFilter?.(search, tags) }), divider] })), selectConfig && (_jsxs(_Fragment, { children: [_jsx(SelectConfig, { config: selectConfig }), divider] })), permissionConfig && _jsx(PermissionConfig, { config: permissionConfig })] }));
}
const PermissionConfig = (props) => {
    const { config } = props;
    const [permissionValue, setPermissionValue] = React.useState(null);
    const loseFocus = () => {
        setTimeout(() => {
            const focused = document.querySelector(':focus');
            setPermissionValue(null);
            focused?.blur();
        }, 0);
    };
    return (_jsxs(_Fragment, { children: [_jsxs(FlexBox, { vAlign: "center", hAlign: "space-between", px: 2, py: 1, gap: 2, sx: { scrollbarGutter: 'stable', overflowY: 'auto' }, children: [_jsxs(Typography, { color: "text.secondary", children: [config.texts.withPermission, " (", config.currentNum, ")"] }), _jsx(Autocomplete, { disableSearch: true, value: permissionValue, sx: {
                            flexBasis: FACILITY_PICKER_PERMISSION_WIDTH,
                            flexGrow: 0,
                            flexShrink: 0
                        }, options: [
                            'WRITE',
                            'READ',
                            'NONE'
                        ], getOptionLabel: (option) => config.texts.options[option], label: `${config.texts.changePermission} (${config.totalNum})`, onChange: (value, event, reason) => {
                            setPermissionValue(value);
                            loseFocus();
                            if (value) {
                                config.onChange?.(value, event, reason);
                            }
                        } })] }), _jsx(Divider, {})] }));
};
const SelectConfig = (props) => {
    const { selected, total, selectAll, selectNone, onChange } = props.config;
    const checked = selected.every((f) => total.includes(f)) &&
        selected.length === total.length;
    return (_jsx(FlexBox, { width: "100%", vAlign: "center", padding: [0, 3.5], gap: 1, stretch: true, children: _jsx(Checkbox, { label: checked
                ? `${selectNone} (${total.length})`
                : `${selectAll} (${total.length})`, onChange: onChange, checked: checked, labelProps: {
                sx: {
                    gap: 1,
                    '.MuiTypography-root': {
                        fontWeight: 500
                    }
                }
            } }) }));
};
